<template>
  <div class="ebsn-3d-viewer-options pa-3">
    <h3 v-if="config?.length > 0">Personalizza</h3>
    <v-form ref="form" v-model="isValid">
      <div
        v-for="conf in config"
        :key="conf.productOptGroup.productOptGroupId"
        class="pb-2"
      >
        <div v-if="conf.productOptGroup.modeName === 'text'">
          <label>{{ conf.productOptGroup.name }}</label>
          <v-textarea
            :placeholder="conf.productOpts[0].productOpt.description"
            v-model="selectedOptions[conf.productOptGroup.productOptGroupId]"
            @change="updateRouterState()"
            outlined
            dense
            hide-details="auto"
            :rules="textRules"
          ></v-textarea>
        </div>
        <div v-else>
          <v-btn
            outlined
            block
            height="42"
            @click="openDrawer(conf)"
            class="option-button"
            :class="{
              'error--text':
                showErrors &&
                buttonErrors[conf.productOptGroup.productOptGroupId]
            }"
            :style="
              showErrors && buttonErrors[conf.productOptGroup.productOptGroupId]
                ? 'border-color: var(--v-error-base) !important'
                : ''
            "
          >
            <div class="d-flex justify-space-between w-100">
              <span class="option-title">{{ conf.productOptGroup.name }}</span>
              <span>
                {{
                  conf.productOpts.find(opt => opt.selected)?.productOpt
                    ?.description || ""
                }}
              </span>
            </div>
          </v-btn>
          <div
            v-if="
              showErrors && buttonErrors[conf.productOptGroup.productOptGroupId]
            "
            class="error--text text-caption mt-1 ml-3"
          >
            {{ buttonErrors[conf.productOptGroup.productOptGroupId] }}
          </div>
        </div>
      </div>
    </v-form>
    <v-navigation-drawer v-model="drawer" temporary right fixed width="460">
      <div v-if="selectedGroup">
        <Ebsn3dViewerBtnToggle
          :conf="selectedGroup"
          :modelValue="
            selectedOptions[selectedGroup.productOptGroup.productOptGroupId]
          "
          @update:modelValue="
            newValue =>
              handleOptionChange(
                newValue,
                selectedGroup.productOptGroup.productOptGroupId
              )
          "
          @close="drawer = false"
        />
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { isRegexp, maxLength } from "@/commons/validator/validationRules";
import Ebsn3dViewerBtnToggle from "./Ebsn3dViewerBtnToggle.vue";

export default {
  name: "Ebsn3dViewerOptions",
  emits: ["option:set", "option:unset, update:validity"],
  components: { Ebsn3dViewerBtnToggle },
  props: {
    config: { type: Array },
    initOptions: { type: Object, default: () => {} }
  },
  data() {
    return {
      selectedOptions: {},
      drawer: false,
      isValid: false,
      selectedGroup: null,
      textRules: [
        maxLength(50),
        isRegexp(
          /^[a-zA-Z0-9:,.!? -]*$/,
          "Il campo contiene caratteri non validi."
        )
      ],
      buttonErrors: {},
      showErrors: false
    };
  },
  watch: {
    isValid: {
      handler() {
        this.validateAllOptions();
      },
      immediate: true
    },
    initOptions: {
      handler(newOptions) {
        if (newOptions !== undefined && Object.keys(newOptions).length > 0) {
          this.selectedOptions = { ...newOptions };
        } else {
          this.selectedOptions = {};
          this.showErrors = false;
          this.buttonErrors = {};
        }
      },
      deep: true
    }
  },

  methods: {
    validateAllOptions() {
      this.buttonErrors = {};
      let allValid = this.isValid;

      if (this.showErrors) {
        this.config.forEach(conf => {
          if (conf.productOptGroup.modeName !== "text") {
            const groupId = conf.productOptGroup.productOptGroupId;
            if (!this.selectedOptions[groupId]) {
              this.buttonErrors[groupId] = "Seleziona un'opzione";
              allValid = false;
            }
          }
        });
      } else {
        this.config.forEach(conf => {
          if (conf.productOptGroup.modeName !== "text") {
            const groupId = conf.productOptGroup.productOptGroupId;
            if (!this.selectedOptions[groupId]) {
              allValid = false;
            }
          }
        });
      }

      this.$emit("update:validity", allValid);
      return allValid;
    },
    triggerValidation() {
      this.showErrors = true;
      this.$refs.form?.validate();
      return this.validateAllOptions();
    },
    selectedOptionsChanged() {
      let query = {};
      for (let key in this.selectedOptions) {
        if (this.selectedOptions[key]) {
          query[`PRODUCT_OPT_${this.selectedOptions[key]}`] = true;
        }
      }
      this.$router.replace({
        params: {
          ignoreScrollBehavior: true
        },
        query
      });
    },
    handleOptionChange(newValue, groupId) {
      this.selectedOptions[groupId] = newValue;
      if (this.showErrors) {
        this.buttonErrors[groupId] = null;
      }
      this.updateRouterState();
      this.validateAllOptions();
    },
    updateRouterState() {
      const query = {};
      console.log(this.selectedOptions);

      for (const groupId in this.selectedOptions) {
        const value = this.selectedOptions[groupId];

        if (!value) continue;

        const groupConfig = this.config.find(
          c => c.productOptGroup.productOptGroupId == groupId
        );
        if (!groupConfig) continue;

        if (groupConfig.productOptGroup.modeName === "text") {
          const optionId = groupConfig.productOpts[0].productOpt.productOptId;
          query[`PRODUCT_OPT_${optionId}`] = value;
        } else {
          query[`PRODUCT_OPT_${value}`] = true;
        }
      }

      this.$router.replace({
        query,
        params: { ignoreScrollBehavior: true }
      });
    },
    getSelectOptionByProductProductOptId(productProductOptId) {
      let resultOpt = undefined;
      this.config.forEach(productOptType => {
        let findedOpt = productOptType.productOpts.find(opt => {
          return opt.productProductOptId == productProductOptId;
        });
        if (findedOpt) {
          console.log("findedOpt", findedOpt);
          resultOpt = findedOpt;
          return;
        }
      });
      return resultOpt;
    },
    openDrawer(conf) {
      this.drawer = true;
      this.selectedGroup = conf;
    }
  },
  computed: {},
  mounted() {
    if (this.initOptions != undefined) {
      this.selectedOptions = { ...this.initOptions };
    }
    this.validateAllOptions();
  },
  created() {}
};
</script>

<style lang="scss">
.ebsn-3d-viewer-options {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .option-button {
    border-color: var(--v-grey-darken1);
    .option-title {
      text-transform: none;
      font-weight: 400;
    }
  }
}
</style>
